export const jobs = [
  {
    id: 0,
    company: "RD Station",
    positions: [
      {
        title: "Front-end Software Engineer",
        date: "(nov 2023 - present) - fully remote",
        description:
          "Led frontend implementation for the SMS Team, including the design and delivery of a full SMS Automation feature using a micro-frontend strategy.",
        impact: [
          "Designed and implemented micro-frontend architecture (Module Federation Shell), enabling independent deployments, modular scaling, and improved maintainability across teams",
          "Developed reusable components at Tangram Design System, reducing development time by 80.7% and boosting cross-team consistency",
          "Optimized frontend performance across multiple modules, reducing page load time by 94.6% through debouncing, caching layers, code splitting, and lazy loading",
          "Achieved sub-second rendering times for complex UI components by restructuring critical rendering paths",
          "Led Growth Strategies for the SMS Team, resulting in an increase of over 43.2% of package use and 22.7% increase in revenue",
          "Performed 100+ code reviews, reducing PR-related incidents by 11% through improved documentation, coding standards, and review processes",
          "Implemented full-coverage testing from unit and integration to E2E testing strategies, maintaining 90%+ coverage",
          "Led microservices frontend monitoring implementation via Rollbar, increasing error visibility by 24% and improving operational response times",
          "Collaborated closely with backend teams to deliver seamless API integrations and improve communication across distributed systems",
        ],
      },
    ],
  },
  {
    id: 1,
    company: "Lopti AI",
    positions: [
      {
        title: "Senior Frontend Engineer and Frontend Lead",
        date: "(march 2025 - march 2026) - fully remote",
        description:
          "Led the implementation of Lopti Lite, an AI-driven product, defining architecture, development standards, and end-to-end delivery using Next.js.",
        impact: [
          "Led a team of frontend developers from inception through full product scalation, guiding technical decisions and team growth at every stage",
          "Reduced production bugs by 72% through improved product structure, automated checks, and proactive quality practices",
          "Established team-wide coding best practices — PR reviews, standardized PR descriptions, agile workflows, and testing guidelines — increasing development efficiency and code quality",
          "Designed and rolled out a feature-based architecture, enabling faster scalability, cleaner separation of concerns, and easier long-term maintenance",
          "Implemented a micro-frontend architecture for the Legal AI chat, allowing seamless reuse across multiple products and simplifying integration",
        ],
      },
    ],
  },
  {
    id: 2,
    company: "Digital Horizon Blockchain Technology",
    positions: [
      {
        title: "Full-stack Software Engineer",
        date: "(feb 2023 - nov 2023) - hybrid",
        description:
          "Designed and architected fintech projects using Next.js, React.js and Node.js, improving cross-platform compatibility to 90%.",
        impact: [
          'Designed and architected fintech projects (e.g., "BCX" and "Truther") using Next.js, React.js and Node.js, improving cross-platform compatibility to 90%',
          "Optimized API performance, reducing response time by 63.4% through microservices architecture",
          "Enhanced product accessibility by ensuring cross-browser compatibility and responsive design",
        ],
      },
    ],
  },
  {
    id: 3,
    company: "Self-Employed",
    positions: [
      {
        title: "Freelancer Full-Stack Software Developer",
        date: "(sept 2021 - present) - fully remote",
        description:
          "Delivered end-to-end web solutions for startups and clients, from MVPs to polished production apps.",
        impact: [
          "Delivered 5+ projects for startups, including a successful MVP, improving client conversion rates by 35%",
          "Reduced application load times by 40% through frontend optimizations and performance tuning",
          "Developed 20+ landing pages and websites, focusing on user-centric design and responsive layouts",
        ],
      },
    ],
  },
];
